import * as React from "react";
import { useEffect, useRef, useState } from "react";
export function ModelControlInput({ currentValue, defaultValue, onChangeHandler, useRelativeChanges, stepSize, disabled, tooltip, disabledTooltip, tooltipPosition, range }) {
    const previousValue = useRef(0);
    const [currentValueState, setCurrentValueState] = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "0");
    const defaultStepsize = 0.1;
    useEffect(() => {
        if (!useRelativeChanges) {
            if (Number.parseFloat(currentValue !== null && currentValue !== void 0 ? currentValue : "0") !== Number.parseFloat(currentValueState !== null && currentValueState !== void 0 ? currentValueState : "0")) {
                setCurrentValueState(currentValue);
            }
        }
    }, [currentValue]);
    useEffect(() => {
        if (useRelativeChanges) {
            setCurrentValueState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "0");
            previousValue.current = Number.parseFloat(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "0");
        }
        else {
            setCurrentValueState(currentValue);
        }
    }, [useRelativeChanges]);
    const handleValueChange = (value) => {
        const newValue = Number.parseFloat(value);
        setCurrentValueState(value);
        if (isNaN(newValue))
            return;
        if (useRelativeChanges) {
            const defaultNum = Number.parseFloat(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "0");
            if (defaultNum === 0) {
                onChangeHandler((newValue - previousValue.current).toString());
            }
            else {
                onChangeHandler((newValue / previousValue.current).toString());
            }
            previousValue.current = newValue;
        }
        else {
            onChangeHandler(value);
        }
    };
    return (React.createElement("input", { type: "number", step: stepSize !== null && stepSize !== void 0 ? stepSize : defaultStepsize, value: currentValueState, min: range === null || range === void 0 ? void 0 : range.min, max: range === null || range === void 0 ? void 0 : range.max, className: "small-input", onChange: (e) => {
            handleValueChange(e.target.value);
        }, disabled: disabled, "data-tooltip": tooltip, "data-tooltip-disabled": disabledTooltip, "data-tooltip-position": tooltipPosition !== null && tooltipPosition !== void 0 ? tooltipPosition : "bottom-right" }));
}
